import axios from 'axios'

const state = () => ({
  all: [],
})

const getters = {
  all (state) {
    return state.all
  },
}

const mutations = {
  SET_AREAS (state, areas) {
    state.all = areas
  },
}

const actions = {
  async index ({ commit }, params) {
    const response = await axios.get('/areas', { params })
    commit('SET_AREAS', response.data.data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}